export default [
  {
    name: "Andorra",
    iso2: "AD",
  },
  {
    name: "United Arab Emirates",
    iso2: "AE",
  },
  {
    name: "Afghanistan",
    iso2: "AF",
  },
  {
    name: "Antigua & Barbuda",
    iso2: "AG",
  },
  {
    name: "Anguilla",
    iso2: "AI",
  },
  {
    name: "Albania",
    iso2: "AL",
  },
  {
    name: "Armenia",
    iso2: "AM",
  },
  {
    name: "Angola",
    iso2: "AO",
  },
  {
    name: "Antarctica",
    iso2: "AQ",
  },
  {
    name: "Argentina",
    iso2: "AR",
  },
  {
    name: "Samoa (American)",
    iso2: "AS",
  },
  {
    name: "Austria",
    iso2: "AT",
  },
  {
    name: "Australia",
    iso2: "AU",
  },
  {
    name: "Aruba",
    iso2: "AW",
  },
  {
    name: "Åland Islands",
    iso2: "AX",
  },
  {
    name: "Azerbaijan",
    iso2: "AZ",
  },
  {
    name: "Bosnia & Herzegovina",
    iso2: "BA",
  },
  {
    name: "Barbados",
    iso2: "BB",
  },
  {
    name: "Bangladesh",
    iso2: "BD",
  },
  {
    name: "Belgium",
    iso2: "BE",
  },
  {
    name: "Burkina Faso",
    iso2: "BF",
  },
  {
    name: "Bulgaria",
    iso2: "BG",
  },
  {
    name: "Bahrain",
    iso2: "BH",
  },
  {
    name: "Burundi",
    iso2: "BI",
  },
  {
    name: "Benin",
    iso2: "BJ",
  },
  {
    name: "St Barthelemy",
    iso2: "BL",
  },
  {
    name: "Bermuda",
    iso2: "BM",
  },
  {
    name: "Brunei",
    iso2: "BN",
  },
  {
    name: "Bolivia",
    iso2: "BO",
  },
  {
    name: "Caribbean NL",
    iso2: "BQ",
  },
  {
    name: "Brazil",
    iso2: "BR",
  },
  {
    name: "Bahamas",
    iso2: "BS",
  },
  {
    name: "Bhutan",
    iso2: "BT",
  },
  {
    name: "Bouvet Island",
    iso2: "BV",
  },
  {
    name: "Botswana",
    iso2: "BW",
  },
  {
    name: "Belarus",
    iso2: "BY",
  },
  {
    name: "Belize",
    iso2: "BZ",
  },
  {
    name: "Canada",
    iso2: "CA",
  },
  {
    name: "Cocos (Keeling) Islands",
    iso2: "CC",
  },
  {
    name: "Congo (Dem. Rep.)",
    iso2: "CD",
  },
  {
    name: "Central African Rep.",
    iso2: "CF",
  },
  {
    name: "Congo (Rep.)",
    iso2: "CG",
  },
  {
    name: "Switzerland",
    iso2: "CH",
  },
  {
    name: "Côte d'Ivoire",
    iso2: "CI",
  },
  {
    name: "Cook Islands",
    iso2: "CK",
  },
  {
    name: "Chile",
    iso2: "CL",
  },
  {
    name: "Cameroon",
    iso2: "CM",
  },
  {
    name: "China",
    iso2: "CN",
  },
  {
    name: "Colombia",
    iso2: "CO",
  },
  {
    name: "Costa Rica",
    iso2: "CR",
  },
  {
    name: "Cuba",
    iso2: "CU",
  },
  {
    name: "Cape Verde",
    iso2: "CV",
  },
  {
    name: "Curaçao",
    iso2: "CW",
  },
  {
    name: "Christmas Island",
    iso2: "CX",
  },
  {
    name: "Cyprus",
    iso2: "CY",
  },
  {
    name: "Czech Republic",
    iso2: "CZ",
  },
  {
    name: "Germany",
    iso2: "DE",
  },
  {
    name: "Djibouti",
    iso2: "DJ",
  },
  {
    name: "Denmark",
    iso2: "DK",
  },
  {
    name: "Dominica",
    iso2: "DM",
  },
  {
    name: "Dominican Republic",
    iso2: "DO",
  },
  {
    name: "Algeria",
    iso2: "DZ",
  },
  {
    name: "Ecuador",
    iso2: "EC",
  },
  {
    name: "Estonia",
    iso2: "EE",
  },
  {
    name: "Egypt",
    iso2: "EG",
  },
  {
    name: "Western Sahara",
    iso2: "EH",
  },
  {
    name: "Eritrea",
    iso2: "ER",
  },
  {
    name: "Spain",
    iso2: "ES",
  },
  {
    name: "Ethiopia",
    iso2: "ET",
  },
  {
    name: "Finland",
    iso2: "FI",
  },
  {
    name: "Fiji",
    iso2: "FJ",
  },
  {
    name: "Falkland Islands",
    iso2: "FK",
  },
  {
    name: "Micronesia",
    iso2: "FM",
  },
  {
    name: "Faroe Islands",
    iso2: "FO",
  },
  {
    name: "France",
    iso2: "FR",
  },
  {
    name: "Gabon",
    iso2: "GA",
  },
  {
    name: "Britain (UK)",
    iso2: "GB",
  },
  {
    name: "Grenada",
    iso2: "GD",
  },
  {
    name: "Georgia",
    iso2: "GE",
  },
  {
    name: "French Guiana",
    iso2: "GF",
  },
  {
    name: "Guernsey",
    iso2: "GG",
  },
  {
    name: "Ghana",
    iso2: "GH",
  },
  {
    name: "Gibraltar",
    iso2: "GI",
  },
  {
    name: "Greenland",
    iso2: "GL",
  },
  {
    name: "Gambia",
    iso2: "GM",
  },
  {
    name: "Guinea",
    iso2: "GN",
  },
  {
    name: "Guadeloupe",
    iso2: "GP",
  },
  {
    name: "Equatorial Guinea",
    iso2: "GQ",
  },
  {
    name: "Greece",
    iso2: "GR",
  },
  {
    name: "South Georgia & the South Sandwich Islands",
    iso2: "GS",
  },
  {
    name: "Guatemala",
    iso2: "GT",
  },
  {
    name: "Guam",
    iso2: "GU",
  },
  {
    name: "Guinea-Bissau",
    iso2: "GW",
  },
  {
    name: "Guyana",
    iso2: "GY",
  },
  {
    name: "Hong Kong",
    iso2: "HK",
  },
  {
    name: "Heard Island & McDonald Islands",
    iso2: "HM",
  },
  {
    name: "Honduras",
    iso2: "HN",
  },
  {
    name: "Croatia",
    iso2: "HR",
  },
  {
    name: "Haiti",
    iso2: "HT",
  },
  {
    name: "Hungary",
    iso2: "HU",
  },
  {
    name: "Indonesia",
    iso2: "ID",
  },
  {
    name: "Ireland",
    iso2: "IE",
  },
  {
    name: "Israel",
    iso2: "IL",
  },
  {
    name: "Isle of Man",
    iso2: "IM",
  },
  {
    name: "India",
    iso2: "IN",
  },
  {
    name: "British Indian Ocean Territory",
    iso2: "IO",
  },
  {
    name: "Iraq",
    iso2: "IQ",
  },
  {
    name: "Iran",
    iso2: "IR",
  },
  {
    name: "Iceland",
    iso2: "IS",
  },
  {
    name: "Italy",
    iso2: "IT",
  },
  {
    name: "Jersey",
    iso2: "JE",
  },
  {
    name: "Jamaica",
    iso2: "JM",
  },
  {
    name: "Jordan",
    iso2: "JO",
  },
  {
    name: "Japan",
    iso2: "JP",
  },
  {
    name: "Kenya",
    iso2: "KE",
  },
  {
    name: "Kyrgyzstan",
    iso2: "KG",
  },
  {
    name: "Cambodia",
    iso2: "KH",
  },
  {
    name: "Kiribati",
    iso2: "KI",
  },
  {
    name: "Comoros",
    iso2: "KM",
  },
  {
    name: "St Kitts & Nevis",
    iso2: "KN",
  },
  {
    name: "Korea (North)",
    iso2: "KP",
  },
  {
    name: "Korea (South)",
    iso2: "KR",
  },
  {
    name: "Kuwait",
    iso2: "KW",
  },
  {
    name: "Cayman Islands",
    iso2: "KY",
  },
  {
    name: "Kazakhstan",
    iso2: "KZ",
  },
  {
    name: "Laos",
    iso2: "LA",
  },
  {
    name: "Lebanon",
    iso2: "LB",
  },
  {
    name: "St Lucia",
    iso2: "LC",
  },
  {
    name: "Liechtenstein",
    iso2: "LI",
  },
  {
    name: "Sri Lanka",
    iso2: "LK",
  },
  {
    name: "Liberia",
    iso2: "LR",
  },
  {
    name: "Lesotho",
    iso2: "LS",
  },
  {
    name: "Lithuania",
    iso2: "LT",
  },
  {
    name: "Luxembourg",
    iso2: "LU",
  },
  {
    name: "Latvia",
    iso2: "LV",
  },
  {
    name: "Libya",
    iso2: "LY",
  },
  {
    name: "Morocco",
    iso2: "MA",
  },
  {
    name: "Monaco",
    iso2: "MC",
  },
  {
    name: "Moldova",
    iso2: "MD",
  },
  {
    name: "Montenegro",
    iso2: "ME",
  },
  {
    name: "St Martin (French)",
    iso2: "MF",
  },
  {
    name: "Madagascar",
    iso2: "MG",
  },
  {
    name: "Marshall Islands",
    iso2: "MH",
  },
  {
    name: "North Macedonia",
    iso2: "MK",
  },
  {
    name: "Mali",
    iso2: "ML",
  },
  {
    name: "Myanmar (Burma)",
    iso2: "MM",
  },
  {
    name: "Mongolia",
    iso2: "MN",
  },
  {
    name: "Macau",
    iso2: "MO",
  },
  {
    name: "Northern Mariana Islands",
    iso2: "MP",
  },
  {
    name: "Martinique",
    iso2: "MQ",
  },
  {
    name: "Mauritania",
    iso2: "MR",
  },
  {
    name: "Montserrat",
    iso2: "MS",
  },
  {
    name: "Malta",
    iso2: "MT",
  },
  {
    name: "Mauritius",
    iso2: "MU",
  },
  {
    name: "Maldives",
    iso2: "MV",
  },
  {
    name: "Malawi",
    iso2: "MW",
  },
  {
    name: "Mexico",
    iso2: "MX",
  },
  {
    name: "Malaysia",
    iso2: "MY",
  },
  {
    name: "Mozambique",
    iso2: "MZ",
  },
  {
    name: "Namibia",
    iso2: "NA",
  },
  {
    name: "New Caledonia",
    iso2: "NC",
  },
  {
    name: "Niger",
    iso2: "NE",
  },
  {
    name: "Norfolk Island",
    iso2: "NF",
  },
  {
    name: "Nigeria",
    iso2: "NG",
  },
  {
    name: "Nicaragua",
    iso2: "NI",
  },
  {
    name: "Netherlands",
    iso2: "NL",
  },
  {
    name: "Norway",
    iso2: "NO",
  },
  {
    name: "Nepal",
    iso2: "NP",
  },
  {
    name: "Nauru",
    iso2: "NR",
  },
  {
    name: "Niue",
    iso2: "NU",
  },
  {
    name: "New Zealand",
    iso2: "NZ",
  },
  {
    name: "Oman",
    iso2: "OM",
  },
  {
    name: "Panama",
    iso2: "PA",
  },
  {
    name: "Peru",
    iso2: "PE",
  },
  {
    name: "French Polynesia",
    iso2: "PF",
  },
  {
    name: "Papua New Guinea",
    iso2: "PG",
  },
  {
    name: "Philippines",
    iso2: "PH",
  },
  {
    name: "Pakistan",
    iso2: "PK",
  },
  {
    name: "Poland",
    iso2: "PL",
  },
  {
    name: "St Pierre & Miquelon",
    iso2: "PM",
  },
  {
    name: "Pitcairn",
    iso2: "PN",
  },
  {
    name: "Puerto Rico",
    iso2: "PR",
  },
  {
    name: "Palestine",
    iso2: "PS",
  },
  {
    name: "Portugal",
    iso2: "PT",
  },
  {
    name: "Palau",
    iso2: "PW",
  },
  {
    name: "Paraguay",
    iso2: "PY",
  },
  {
    name: "Qatar",
    iso2: "QA",
  },
  {
    name: "Réunion",
    iso2: "RE",
  },
  {
    name: "Romania",
    iso2: "RO",
  },
  {
    name: "Serbia",
    iso2: "RS",
  },
  {
    name: "Russia",
    iso2: "RU",
  },
  {
    name: "Rwanda",
    iso2: "RW",
  },
  {
    name: "Saudi Arabia",
    iso2: "SA",
  },
  {
    name: "Solomon Islands",
    iso2: "SB",
  },
  {
    name: "Seychelles",
    iso2: "SC",
  },
  {
    name: "Sudan",
    iso2: "SD",
  },
  {
    name: "Sweden",
    iso2: "SE",
  },
  {
    name: "Singapore",
    iso2: "SG",
  },
  {
    name: "St Helena",
    iso2: "SH",
  },
  {
    name: "Slovenia",
    iso2: "SI",
  },
  {
    name: "Svalbard & Jan Mayen",
    iso2: "SJ",
  },
  {
    name: "Slovakia",
    iso2: "SK",
  },
  {
    name: "Sierra Leone",
    iso2: "SL",
  },
  {
    name: "San Marino",
    iso2: "SM",
  },
  {
    name: "Senegal",
    iso2: "SN",
  },
  {
    name: "Somalia",
    iso2: "SO",
  },
  {
    name: "Suriname",
    iso2: "SR",
  },
  {
    name: "South Sudan",
    iso2: "SS",
  },
  {
    name: "Sao Tome & Principe",
    iso2: "ST",
  },
  {
    name: "El Salvador",
    iso2: "SV",
  },
  {
    name: "St Maarten (Dutch)",
    iso2: "SX",
  },
  {
    name: "Syria",
    iso2: "SY",
  },
  {
    name: "Eswatini (Swaziland)",
    iso2: "SZ",
  },
  {
    name: "Turks & Caicos Is",
    iso2: "TC",
  },
  {
    name: "Chad",
    iso2: "TD",
  },
  {
    name: "French S. Terr.",
    iso2: "TF",
  },
  {
    name: "Togo",
    iso2: "TG",
  },
  {
    name: "Thailand",
    iso2: "TH",
  },
  {
    name: "Tajikistan",
    iso2: "TJ",
  },
  {
    name: "Tokelau",
    iso2: "TK",
  },
  {
    name: "East Timor",
    iso2: "TL",
  },
  {
    name: "Turkmenistan",
    iso2: "TM",
  },
  {
    name: "Tunisia",
    iso2: "TN",
  },
  {
    name: "Tonga",
    iso2: "TO",
  },
  {
    name: "Turkey",
    iso2: "TR",
  },
  {
    name: "Trinidad & Tobago",
    iso2: "TT",
  },
  {
    name: "Tuvalu",
    iso2: "TV",
  },
  {
    name: "Taiwan",
    iso2: "TW",
  },
  {
    name: "Tanzania",
    iso2: "TZ",
  },
  {
    name: "Ukraine",
    iso2: "UA",
  },
  {
    name: "Uganda",
    iso2: "UG",
  },
  {
    name: "US minor outlying islands",
    iso2: "UM",
  },
  {
    name: "United States",
    iso2: "US",
  },
  {
    name: "Uruguay",
    iso2: "UY",
  },
  {
    name: "Uzbekistan",
    iso2: "UZ",
  },
  {
    name: "Vatican City",
    iso2: "VA",
  },
  {
    name: "St Vincent",
    iso2: "VC",
  },
  {
    name: "Venezuela",
    iso2: "VE",
  },
  {
    name: "Virgin Islands (UK)",
    iso2: "VG",
  },
  {
    name: "Virgin Islands (US)",
    iso2: "VI",
  },
  {
    name: "Vietnam",
    iso2: "VN",
  },
  {
    name: "Vanuatu",
    iso2: "VU",
  },
  {
    name: "Wallis & Futuna",
    iso2: "WF",
  },
  {
    name: "Samoa (western)",
    iso2: "WS",
  },
  {
    name: "Yemen",
    iso2: "YE",
  },
  {
    name: "Mayotte",
    iso2: "YT",
  },
  {
    name: "South Africa",
    iso2: "ZA",
  },
  {
    name: "Zambia",
    iso2: "ZM",
  },
  {
    name: "Zimbabwe",
    iso2: "ZW",
  },
];
